// 기사 전용 포탈 (실물 파이프라인 PL-1, 2026-07-11) — 모바일 웹 우선.
//   본인 배정(driver_assignments) 수신 → 수락/거절 → 픽업/도착 단계 체크인 (GPS 없음 — Jin 확정).
//   백엔드: routes/drivers.js (/driver/me, /driver/assignments, accept/decline/checkin). CarrierPortal 패턴 미러.
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var NAVY = '#1B3A5C';
var A_LABEL = { assigned: '배정 대기', accepted: '수락됨', in_transit: '운송중', delivered: '인도 완료' };
var A_COLOR = { assigned: '#ea580c', accepted: '#2563eb', in_transit: '#7c3aed', delivered: '#16a34a' };

function DriverPortal({ showToast }) {
  var st = showToast || function () {};
  var meState = useState(null); var me = meState[0]; var setMe = meState[1];
  var listState = useState([]); var list = listState[0]; var setList = listState[1];
  var detailState = useState(null); var detail = detailState[0]; var setDetail = detailState[1];
  var busyState = useState(false); var busy = busyState[0]; var setBusy = busyState[1]; // 더블탭 이중 요청 차단 (ShoringIntake 패턴)
  var photosState = useState({}); var photos = photosState[0]; var setPhotos = photosState[1]; // assignId → [{fileName, url}] (체크인 사진)

  function loadMe() { authFetch(API + '/driver/me').then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) setMe(d); }).catch(function () {}); }
  function loadList() { authFetch(API + '/driver/assignments').then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) setList(d.items || []); else st('목록 로드 실패', 'err'); }).catch(function () { st('목록 로드 실패', 'err'); }); }
  useEffect(function () { loadMe(); loadList(); }, []);

  function openDetail(id) { authFetch(API + '/driver/assignments/' + id).then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) setDetail(d.assignment); }).catch(function () {}); }
  function refresh(id) { loadMe(); loadList(); if (id) openDetail(id); }

  function accept(a) {
    if (busy) return;
    setBusy(true);
    authFetch(API + '/driver/assignments/' + a.id + '/accept', { method: 'POST' })
      .then(function (r) { return r.json(); }).then(function (d) { setBusy(false); if (d && d.success) { st('배차를 수락했습니다', ''); refresh(a.id); } else st((d && d.error) || '실패', 'err'); }).catch(function () { setBusy(false); st('실패', 'err'); });
  }
  function decline(a) {
    if (busy) return;
    var reason = window.prompt('거절 사유를 입력하세요');
    if (reason === null) return;
    setBusy(true);
    authFetch(API + '/driver/assignments/' + a.id + '/decline', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ reason: reason }) })
      .then(function (r) { return r.json(); }).then(function (d) { setBusy(false); if (d && d.success) { st('배차를 거절했습니다', ''); setDetail(null); refresh(); } else st((d && d.error) || '실패', 'err'); }).catch(function () { setBusy(false); st('실패', 'err'); });
  }
  function checkin(a, type) {
    if (busy) return;
    var label = type === 'pickup' ? '픽업(차량 인수)' : '쇼링장 도착(인도)';
    if (!window.confirm(label + ' 체크인을 기록할까요?')) return;
    var fileNames = (photos[a.id] || []).map(function (p) { return p.fileName; });
    setBusy(true);
    authFetch(API + '/driver/assignments/' + a.id + '/checkin', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ type: type, photos: fileNames }) })
      .then(function (r) { return r.json(); }).then(function (d) { setBusy(false); if (d && d.success) { st(label + ' 체크인 완료', ''); setPhotos(function (p) { var n = Object.assign({}, p); delete n[a.id]; return n; }); refresh(a.id); } else st((d && d.error) || '실패', 'err'); }).catch(function () { setBusy(false); st('실패', 'err'); });
  }
  // 체크인 사진 — 선택 즉시 업로드 (POST /driver/assignments/:id/photo, multipart field 'photo' → {success, fileName})
  function uploadPhoto(a, file) {
    if (!file || busy) return;
    var fd = new FormData(); fd.append('photo', file);
    setBusy(true);
    authFetch(API + '/driver/assignments/' + a.id + '/photo', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        setBusy(false);
        if (d && d.success && d.fileName) { var url = URL.createObjectURL(file); setPhotos(function (p) { var n = Object.assign({}, p); n[a.id] = (n[a.id] || []).concat([{ fileName: d.fileName, url: url }]); return n; }); st('사진 업로드됨', ''); }
        else st((d && d.error) || '사진 업로드 실패', 'err');
      })
      .catch(function () { setBusy(false); st('사진 업로드 실패', 'err'); });
  }
  function removePhoto(assignId, fileName) {
    setPhotos(function (p) { var n = Object.assign({}, p); n[assignId] = (n[assignId] || []).filter(function (x) { return x.fileName !== fileName; }); return n; });
  }

  function photoBar(a) {
    var items = photos[a.id] || [];
    return (
      <div style={{ marginBottom: 6 }}>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
          {items.map(function (p) {
            return (
              <div key={p.fileName} style={{ position: 'relative' }}>
                <img src={p.url} alt="체크인 사진" style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 8, border: '1px solid #e5e7eb', display: 'block' }} />
                <button onClick={function () { removePhoto(a.id, p.fileName); }} style={{ position: 'absolute', top: -6, right: -6, width: 18, height: 18, borderRadius: 9, border: 'none', background: '#dc2626', color: '#fff', fontSize: 10, lineHeight: '18px', padding: 0, cursor: 'pointer' }}>{'✕'}</button>
              </div>
            );
          })}
          <label style={{ width: 56, height: 56, border: '1px dashed #cbd5e1', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, background: '#f8fafc', cursor: 'pointer', opacity: busy ? 0.5 : 1 }}>
            {'📷'}
            <input type="file" accept="image/*" capture="environment" disabled={busy} style={{ display: 'none' }} onChange={function (e) { uploadPhoto(a, e.target.files && e.target.files[0]); e.target.value = ''; }} />
          </label>
        </div>
        <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 2 }}>{'체크인 사진 ' + items.length + '장 (선택 — 없어도 체크인 가능)'}</div>
      </div>
    );
  }

  function ctaFor(a, big) {
    var s = big ? ctaBig : ctaSmall;
    if (a.current_status === 'assigned') {
      return (
        <div style={{ display: 'flex', gap: 8, width: '100%' }}>
          <button onClick={function () { accept(a); }} disabled={busy} style={Object.assign({}, s, { flex: 2, background: NAVY, color: '#fff', border: 'none' })}>{'✅ 수락'}</button>
          <button onClick={function () { decline(a); }} disabled={busy} style={Object.assign({}, s, { flex: 1, background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca' })}>{'거절'}</button>
        </div>
      );
    }
    if (a.current_status === 'accepted') return <div style={{ width: '100%' }}>{photoBar(a)}<button onClick={function () { checkin(a, 'pickup'); }} disabled={busy} style={Object.assign({}, s, { width: '100%', background: '#7c3aed', color: '#fff', border: 'none' })}>{'📸 픽업 체크인 (차량 인수)'}</button></div>;
    if (a.current_status === 'in_transit') return <div style={{ width: '100%' }}>{photoBar(a)}<button onClick={function () { checkin(a, 'arrival'); }} disabled={busy} style={Object.assign({}, s, { width: '100%', background: '#16a34a', color: '#fff', border: 'none' })}>{'🏁 도착 체크인 (쇼링장 인도)'}</button></div>;
    return null;
  }

  return (
    <div style={{ padding: '16px 14px', maxWidth: 640, margin: '0 auto' }}>
      <div style={{ fontSize: 20, fontWeight: 800, color: NAVY, marginBottom: 2 }}>{'🚗 내 운행'}</div>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 12 }}>{(me && me.name ? me.name + ' 기사님 · ' : '') + '배정된 배차를 수락하고 픽업/도착을 체크인하세요'}</div>

      {me && (
        <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
          {[['assigned', '대기'], ['accepted', '수락'], ['in_transit', '운송중'], ['delivered', '완료']].map(function (p) {
            return (
              <div key={p[0]} style={{ flex: 1, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: '10px 6px', textAlign: 'center' }}>
                <div style={{ fontSize: 20, fontWeight: 800, color: A_COLOR[p[0]] }}>{me.counts[p[0]] || 0}</div>
                <div style={{ fontSize: 11, color: '#64748b' }}>{p[1]}</div>
              </div>
            );
          })}
        </div>
      )}

      {list.length === 0 && <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8', background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12 }}>{'배정된 배차가 없습니다'}</div>}
      {list.map(function (a) {
        return (
          <div key={a.id} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: '12px 14px', marginBottom: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }} onClick={function () { openDetail(a.id); }}>
              <div>
                <span style={{ fontWeight: 800, color: NAVY, fontSize: 15 }}>{a.dispatch_no}</span>
                <span style={{ fontSize: 12, color: '#64748b', marginLeft: 8 }}>{(a.carCount || 0) + '대' + (a.pickup_date ? ' · 픽업 ' + a.pickup_date : '')}</span>
              </div>
              <span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: A_COLOR[a.current_status] || '#94a3b8', borderRadius: 10, padding: '3px 10px' }}>{A_LABEL[a.current_status] || a.current_status}</span>
            </div>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }} onClick={function () { openDetail(a.id); }}>{'쇼링장: ' + (a.shoring_yard || '-')}</div>
            {ctaFor(a, false)}
            <button onClick={function () { openDetail(a.id); }} style={{ width: '100%', marginTop: 6, padding: '8px', background: '#f8fafc', color: '#475569', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{'상세 (차량 · 픽업 주소)'}</button>
          </div>
        );
      })}

      {/* 상세 — 차량 목록 + 픽업 주소 (풀스크린 시트) */}
      {detail && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 9999 }} onClick={function () { setDetail(null); }}>
          <div style={{ background: '#fff', borderRadius: '16px 16px 0 0', padding: '16px 16px 20px', width: '100%', maxWidth: 640, maxHeight: '88vh', display: 'flex', flexDirection: 'column' }} onClick={function (e) { e.stopPropagation(); }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <div style={{ fontSize: 16, fontWeight: 800, color: NAVY }}>{'배차 ' + detail.dispatch_no}</div>
              <span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: A_COLOR[detail.current_status] || '#94a3b8', borderRadius: 10, padding: '3px 10px' }}>{A_LABEL[detail.current_status] || detail.current_status}</span>
            </div>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 10 }}>{'캐리어: ' + (detail.carrierName || '-') + ' · 쇼링장: ' + (detail.shoring_yard || '-') + ' · 픽업일: ' + (detail.pickup_date || '-') + (detail.memo ? ' · ' + detail.memo : '')}</div>
            <div style={{ flex: 1, overflowY: 'auto' }}>
              {(detail.items || []).map(function (it) {
                return (
                  <div key={it.id} style={{ border: '1px solid #f1f5f9', borderRadius: 10, padding: '10px 12px', marginBottom: 8 }}>
                    <div style={{ fontWeight: 700, color: NAVY, fontSize: 14 }}>{(it.seq ? it.seq + '. ' : '') + (it.carNo || '')}</div>
                    <div style={{ fontSize: 12, color: '#64748b' }}>{(it.carType || '') + (it.color ? ' · ' + it.color : '') + (it.vin ? ' · ' + it.vin : '')}</div>
                    <div style={{ fontSize: 13, color: '#334155', marginTop: 4 }}>{'📍 ' + (it.pickup_address || '픽업 주소 미지정')}</div>
                  </div>
                );
              })}
            </div>
            {detail.picked_up_at && <div style={{ fontSize: 11, color: '#94a3b8' }}>{'픽업 체크인: ' + detail.picked_up_at}</div>}
            {detail.arrived_at && <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 6 }}>{'도착 체크인: ' + detail.arrived_at}</div>}
            <div style={{ marginTop: 8 }}>{ctaFor(detail, true)}</div>
            <button onClick={function () { setDetail(null); }} style={{ marginTop: 8, padding: '10px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>{'닫기'}</button>
          </div>
        </div>
      )}
    </div>
  );
}

var ctaSmall = { padding: '10px', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' };
var ctaBig = { padding: '14px', borderRadius: 10, fontSize: 15, fontWeight: 800, cursor: 'pointer' };

export default DriverPortal;
